import React from 'react';
import t from '../../config/translations';
import Header from "../Units/Header";
import '../../assets/stylesheets/LeaderBoard/LeaderBoardHints.scss';

const LeaderBoardHints = ({}) => {

    return (
            <div className={'leaderboardHints'}>
                <Header title='leaderboardHintsTitle' backTo={'/leaderboard/info'} ></Header>
                <div className="leaderBoardHintsList">
                    <div className="hintRow">{t.leaderboardHints.rule}</div>
                    {
                        t.leaderboardHints.hintsText.map((hint) => <div className="hintRow">
                            <span className="hintHeader">{hint.header}</span>
                            <p>{hint.text}</p>
                        </div>)
                    }
                </div>
            </div>
    );
}

export default LeaderBoardHints;
